// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Image from '@tcp/core/src/components/common/atoms/Image';
import RichText from '@tcp/core/src/components/common/atoms/RichText';
import { getIconPath } from '@tcp/core/src/utils/utils';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/SocialProofBanner.style';
import Timer from '../Timer/views/Timer.view';
import { isMobileWeb } from '../../../../../../../utils';

const getRichText = (
  isSiteWidePromoBannerAbTestEnabled,
  isExtendedHolidayReturnsBannerAbTestEnabled,
  isHolidayGetItByMessageBannerAbTestEnabled,
  richTextHtmlDefault,
  richTextHtml1,
  richTextHtml2,
  richTextHtml3
) => {
  if (isSiteWidePromoBannerAbTestEnabled) {
    return richTextHtml1;
  }
  if (isExtendedHolidayReturnsBannerAbTestEnabled) {
    return richTextHtml2;
  }
  if (isHolidayGetItByMessageBannerAbTestEnabled) {
    return richTextHtml3;
  }
  return richTextHtmlDefault;
};

const getIcon = (
  isSiteWidePromoBannerAbTestEnabled,
  isExtendedHolidayReturnsBannerAbTestEnabled,
  isHolidayGetItByMessageBannerAbTestEnabled,
  isDefaultSocialProofBanner
) => {
  if (isDefaultSocialProofBanner) {
    return getIconPath('cart-social-proofing-blue');
  }
  if (isSiteWidePromoBannerAbTestEnabled) {
    return getIconPath('cart-social-proofing-tag-icon');
  }
  if (isExtendedHolidayReturnsBannerAbTestEnabled) {
    return getIconPath('cart-social-proofing-purchase-icon');
  }
  if (isHolidayGetItByMessageBannerAbTestEnabled) {
    return getIconPath('cart-social-proofing-gift-icon');
  }
  return getIconPath('cart-social-proofing-blue');
};

class SocialProofBanner extends React.PureComponent {
  render() {
    const {
      className,
      richTextHtmlDefault,
      richTextHtml1,
      richTextHtml2,
      richTextHtml3,
      isDefaultSocialProofBanner,
      setDefaultBannerAction,
      timerDeadlineValue,
    } = this.props;

    const isSiteWidePromoBannerAbTestEnabled = isDefaultSocialProofBanner
      ? false
      : this.props.isSiteWidePromoBannerAbTestEnabled;
    const isExtendedHolidayReturnsBannerAbTestEnabled = isDefaultSocialProofBanner
      ? false
      : this.props.isExtendedHolidayReturnsBannerAbTestEnabled;
    const isHolidayGetItByMessageBannerAbTestEnabled = isDefaultSocialProofBanner
      ? false
      : this.props.isHolidayGetItByMessageBannerAbTestEnabled;

    function formatRichText(richTextHtml) {
      const regex = /\$(.*?)\$/g;
      return richTextHtml?.replace(regex, '<span style="font-weight: 800;">$1</span>');
    }

    const showTimer =
      isSiteWidePromoBannerAbTestEnabled || isHolidayGetItByMessageBannerAbTestEnabled;
    return (
      <div className={className}>
        <div
          className={
            !isMobileWeb()
              ? 'social-proofing-msg-wrapper-desktop'
              : 'social-proofing-msg-wrapper-mobile'
          }
        >
          <Image
            src={getIcon(
              isSiteWidePromoBannerAbTestEnabled,
              isExtendedHolidayReturnsBannerAbTestEnabled,
              isHolidayGetItByMessageBannerAbTestEnabled,
              isDefaultSocialProofBanner
            )}
            alt="social proofing icon"
            className="social-proof-icon"
          />
          <div className="social-proofing-text-wrapper">
            <div
              className={
                !isMobileWeb() ? 'social-proofing-msg-desktop' : 'social-proofing-msg-mobile'
              }
            >
              <RichText
                richTextHtml={getRichText(
                  isSiteWidePromoBannerAbTestEnabled,
                  isExtendedHolidayReturnsBannerAbTestEnabled,
                  isHolidayGetItByMessageBannerAbTestEnabled,
                  formatRichText(richTextHtmlDefault),
                  formatRichText(richTextHtml1),
                  formatRichText(richTextHtml2),
                  formatRichText(richTextHtml3)
                )}
              />
            </div>
            {showTimer && (
              <div className="social-proofing-timer">
                <Timer
                  setDefaultBannerAction={setDefaultBannerAction}
                  timerDeadlineValue={timerDeadlineValue}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

SocialProofBanner.propTypes = {
  className: PropTypes.string.isRequired,
};
SocialProofBanner.defaultProps = {};

export default withStyles(SocialProofBanner, styles);
export { SocialProofBanner as SocialProofBannerVanilla };
